import { Radio } from 'lucide-react';
import { StatusBadge } from '../ui/status-badge';
export function StreamingLabel() {
    return (<StatusBadge variant="default" includeDot={false}>
      <Radio className="h-3.5 w-3.5"/>
      Streaming Enabled
    </StatusBadge>);
}
